export default __webpack_public_path__ + "static/media/8m-min.5cd847ef.jpg";